import { render } from "./Kraepelin3View.vue?vue&type=template&id=44065464"
import script from "./Kraepelin3View.vue?vue&type=script&lang=js"
export * from "./Kraepelin3View.vue?vue&type=script&lang=js"

import exportComponent from "E:\\2023-1\\sukun\\Sukun-Psikotes-FE-Peserta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__